import React from 'react'
import { BaseIngredient } from '@screens/Ingredients/types'
import { NoSearchResults } from '@screens/Ingredients'
import { Ingredient } from '@src/types'
import { IngredientsList } from './IngredientsList'

export const SceneContent = React.memo(
  ({
    ingredients,
    isCustomTab,
    isLoading,
    query,
    addedIngredients,
    onItemSelect,
    onRemovePress,
    contentContainerStyle,
  }: {
    ingredients: BaseIngredient[]
    isCustomTab?: boolean
    isLoading: boolean
    query: string
    addedIngredients: (Ingredient | BaseIngredient)[]
    onItemSelect: (item: BaseIngredient) => void
    onRemovePress: (item: BaseIngredient) => void
    contentContainerStyle: { paddingBottom: number }
  }) => {
    if (!isLoading && query && ingredients.length === 0 && !isCustomTab) {
      return <NoSearchResults query={query} />
    }

    return (
      <IngredientsList
        ingredients={ingredients}
        isCustomTab={isCustomTab}
        addedIngredients={addedIngredients}
        onItemSelect={onItemSelect}
        onRemovePress={onRemovePress}
        contentContainerStyle={contentContainerStyle}
      />
    )
  },
)
